import { Tooltip, type TooltipProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

type Props = {
  tooltipText?: ReactNode;
  children?: React.JSX.Element;
  icon?: boolean;
  pre?: boolean;
  customContent?: boolean;
} & TooltipProps;

export function TooltipStyled(props: Props) {
  const { children, icon, tooltipText, pre, customContent, ...rest } = props;
  return (
    <Tooltip
      hasArrow
      label={tooltipText}
      fontSize="md"
      placement="auto"
      whiteSpace={pre ? "pre-wrap" : undefined}
      {...rest}
    >
      {customContent ? (
        children
      ) : (
        <span
          style={
            icon
              ? {
                  display: "inline-block",
                  verticalAlign: "middle",
                }
              : undefined
          }
        >
          {children}
        </span>
      )}
    </Tooltip>
  );
}
